import React from 'react';
import { Section, SectionHeader } from '../ui/Section';
import { motion } from 'framer-motion';
interface Genius {
  name: string;
  description: string;
  image: string;
  color: string;
}
const geniuses: Genius[] = [{
  name: 'Leonardo da Vinci',
  description: 'El genio del Renacimiento que unió arte, ciencia e imaginación.',
  image: 'https://cdn.magicpatterns.com/uploads/12fD9nQmVjoaMFTBHh622w/71AF37C5-7914-40CA-9645-3C1678FE1640.png',
  color: 'bg-[#E6DCCF]'
}, {
  name: 'Nikola Tesla',
  description: 'El visionario que soñó con un mundo conectado por energía.',
  image: 'https://cdn.magicpatterns.com/uploads/qx8EftBFsy9QaWMQsUbVn3/290FE31B-98B1-47B6-B762-7412C7774294.png',
  color: 'bg-[#D0D8E6]'
}, {
  name: 'Albert Einstein',
  description: 'El hombre que cambió nuestra comprensión del tiempo y el espacio.',
  image: 'https://cdn.magicpatterns.com/uploads/6y62KwMwr8GEQP7VRmFv9F/A528A077-6A42-4D4A-B6AB-866024365F01.png',
  color: 'bg-[#D0D8E6]'
}, {
  name: 'Marie Curie',
  description: 'La mujer que abrió las puertas de la ciencia moderna con su valentía.',
  image: 'https://cdn.magicpatterns.com/uploads/jSn4mDdVzvyvdcS19yfCbJ/2BC06BD2-F572-4219-8E0A-0E99E0A56E84.png',
  color: 'bg-[#D4CFC5]'
}, {
  name: 'Steve Jobs',
  description: 'El creador que transformó la tecnología en arte.',
  image: 'https://cdn.magicpatterns.com/uploads/k4KxEwHDXXWFQV4xWPJi6C/B9401D46-D31A-4D91-ADB6-E466157C0AED.png',
  color: 'bg-[#F5F0E8]'
}, {
  name: 'Isaac Newton',
  description: 'El científico que reveló las leyes invisibles del universo.',
  image: 'https://cdn.magicpatterns.com/uploads/n3FsoBziyEvkt7DPocWYyt/BBAB052F-5F74-49F9-A476-F29A03B85293.png',
  color: 'bg-[#E6DCCF]'
}];
export function GeniusesSection() {
  return <Section background="cream-dark" data-id="element-32">
      <SectionHeader title="Conoce a los Maestros" subtitle="Seis figuras históricas que redefinieron lo que es posible." data-id="element-33" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-34">
        {geniuses.map((genius, index) => <motion.div key={genius.name} initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="group bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-[#E0D8D0]" data-id="element-35">
            <div className={`aspect-square overflow-hidden relative ${genius.color}`} data-id="element-36">
              {/* Overlay gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10" data-id="element-37"></div>

              <img src={genius.image} alt={genius.name} className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-700" data-id="element-38" />
            </div>

            <div className="p-8" data-id="element-39">
              <h3 className="text-2xl font-serif font-bold text-[#3D2314] mb-3 group-hover:text-[#C9A227] transition-colors" data-id="element-40">
                {genius.name}
              </h3>
              <p className="text-[#5C3D2E] leading-relaxed" data-id="element-41">
                {genius.description}
              </p>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}